var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-table',{ref:"routeTable",attrs:{"data":this.result}},[_c('el-table-column',{attrs:{"label":"SOC","prop":"code"}}),_c('el-table-column',{attrs:{"label":"LPN","prop":"lpn"}}),_c('el-table-column',{attrs:{"label":"RESULTADO","prop":"status"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }